
import { supabase } from "@/integrations/supabase/client";
import { Lesson } from "@/types/course";

/**
 * Creates a new lesson within a module
 */
export async function createLesson(
  module_id: string, 
  title: string, 
  description: string | null, 
  video_url: string | null,
  order_index: number,
  duration: number | null
): Promise<any> {
  const { data, error } = await supabase
    .from('course_lessons')
    .insert({
      module_id,
      title,
      description,
      video_url,
      order_index,
      duration
    })
    .select('*')
    .single();
  
  if (error) throw error;
  
  return data;
}

/**
 * Updates an existing lesson
 */
export async function updateLesson(id: string, updates: {
  title?: string;
  description?: string | null;
  video_url?: string | null;
  order_index?: number;
  duration?: number | null;
}): Promise<any> {
  const { data, error } = await supabase
    .from('course_lessons')
    .update(updates)
    .eq('id', id)
    .select('*')
    .single();
  
  if (error) throw error;
  
  return data;
}

/**
 * Deletes a lesson
 */
export async function deleteLesson(id: string): Promise<void> {
  const { error } = await supabase
    .from('course_lessons')
    .delete()
    .eq('id', id);
  
  if (error) throw error;
}

/**
 * Reorders lessons within a module
 */
export async function reorderLessons(moduleId: string, orderedIds: string[]): Promise<void> {
  // Create an array of promises to execute
  const updates = orderedIds.map((id, index) => {
    return supabase
      .from('course_lessons')
      .update({ order_index: index })
      .eq('id', id)
      .eq('module_id', moduleId)
      .select('id')
      .single(); // Use single() to return a Promise
  });
  
  // Execute all updates in parallel
  await Promise.all(updates);
}
